var FcDataCardV2Component = /** @class */ (function () {
    function FcDataCardV2Component() {
        this.value = 0;
        this.label = '';
        this.description = '';
        this.color = '';
        this.backgroundColor = '';
        this.icon = '';
        this.loading = false;
    }
    return FcDataCardV2Component;
}());
export { FcDataCardV2Component };
